export const numberOfApplicants = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10
]

export const lengthOfVisa = [
  { value: 1, label: 'EVisa - 1 month single' },
  { value: 2, label: 'EVisa - 1 month multiple' },
  { value: 3, label: 'EVisa - 3 months single' },
  { value: 4, label: 'EVisa - 3 months multiple' }
]

export const purposeOfTravel = [
  { value: 1, label: 'Tourist' },
  { value: 2, label: 'Business' }
]

export const portList = [
  { value: 1, label: 'Tan Son Nhat Int Airport (Ho Chi Minh City)' },
  { value: 2, label: 'Noi Bai Int Airport (Ha Noi)' }
]

export const processingTimeList = [
  { value: 1, label: 'Normal', summary: '4 working day', description: 'Granted visa sent after 4 working days via email (8:00 AM to 5:00 PM Vietnam time, excluding Saturday and Sunday)', price: 0 },
  { value: 2, label: 'URGENT', summary: '2 working days', description: 'Granted visa sent after 2 working days via email (8:00 AM to 5:00 PM Vietnam time, excluding Saturday and Sunday)', price: 40 },
  { value: 3, label: 'SUPER URGENT', summary: '1 working day', description: 'Granted visa sent the next day via email (8:00 AM to 5:00 PM Vietnam time, excluding Saturday and Sunday)', price: 80 },
  { value: 4, label: 'Express', summary: '4 working hours', description: 'Visa Approval Letter (VOA) sent after 4 working hours the same date and Granted Evisa sent after 4 working hours the next day via email (8:00 AM to 5:00 PM Vietnam time, excluding Saturday and Sunday). For urgent requests, kindly contact our hotline at <a href="tel:+84.357.522.522">+84.357.522.522</a> or our email: <a href="mailto:sales@vietnam-immi.org">sales@vietnam-immi.org</a> to receive a granted visa in 15 - 30 business minutes.', price: 120 },
  { value: 5, label: 'Emergency', summary: '2 working hours', description: 'Granted Evisa sent after 2 working hours the same date via email (8:00 AM to 5:00 PM Vietnam time, excluding Saturday and Sunday). For urgent requests, kindly contact our hotline at <a href="tel:+84.357.522.522">+84.357.522.522</a> or our email: <a href="mailto:sales@vietnam-immi.org">sales@vietnam-immi.org</a> to receive a granted visa in 15 - 30 business minutes.', price: 200 },
  { value: 6, label: 'Weekend or Holiday', summary: 'Last Minute Visa Service', description: 'It is available for who not apply visa yet but arrival date is the same day, weekend or holiday. 320 USD/person all include, no extra charged. 24/7 support available.', price: 320 },
]

export const esimTypeList = [
  { value: 1, label: 'Viettel', price: 15 },
  { value: 2, label: 'Mobifone', price: 15 },
  { value: 3, label: 'Vinaphone', price: 15 }
]

export const genderList = [
  { value: 1, label: 'Male' },
  { value: 1, label: 'Female' }
]